import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { DynamicTableComponent } from './dynamic-table/dynamic-table.component';
import { CollapsibleCardComponent } from './collapsible-card/collapsible-card.component';
import { TableSearchBarComponent } from './dynamic-table/table-search-bar/table-search-bar.component';
import { TableButtonsWrapperComponent } from './dynamic-table/table-buttons-wrapper/table-buttons-wrapper.component';
import { TableTextFiltersComponent } from './dynamic-table/table-text-filters/table-text-filters.component';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { DateFormatterService } from '../_services/date-formatter.service';
import { MomentPipe } from '../_pipes/moment.pipe';
import { NgxSpinnerModule } from "ngx-spinner";
import { SpinnerInterceptor } from '../_services/spinner.interceptor';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { SignaturePadComponent } from './signature-pad/signature-pad.component';
import { TagInputModule } from 'ngx-chips';
import { ZXingScannerModule } from '@zxing/ngx-scanner';
import { NgxPaginationModule } from 'ngx-pagination';
//import { PdfJsViewerModule } from 'ng2-pdfjs-viewer';
import { ConfirmationModalComponent } from './confirmation-modal/confirmation-modal.component';
//import { ImageToDataUrlDirective } from 'ngx-image2dataurl';

export function httpTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgxPaginationModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: httpTranslateLoader,
        deps: [HttpClient]
      },
      isolate: false
    })
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    NgxSpinnerModule,
    ZXingScannerModule,
    DynamicTableComponent,
    CollapsibleCardComponent,
    TableSearchBarComponent,
    TableButtonsWrapperComponent,
    PdfViewerModule,
    TableTextFiltersComponent,
    MomentPipe,
    SignaturePadComponent,
    TagInputModule,
    NgxPaginationModule,
    //PdfJsViewerModule,
    ConfirmationModalComponent
  ],
  providers: [
    { provide: NgbDateParserFormatter, useClass: DateFormatterService },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SpinnerInterceptor,
      multi: true
    }
  ],
  declarations: [
    CollapsibleCardComponent,
    DynamicTableComponent,
    TableSearchBarComponent,
    TableButtonsWrapperComponent,
    TableTextFiltersComponent,
    MomentPipe,
    SignaturePadComponent,
    ConfirmationModalComponent
  ]
})
export class SharedModule { }
